import { render } from "./AddonDigital.vue?vue&type=template&id=5f360c80&scoped=true"
import script from "./AddonDigital.vue?vue&type=script&lang=js"
export * from "./AddonDigital.vue?vue&type=script&lang=js"

import "./AddonDigital.vue?vue&type=style&index=0&id=5f360c80&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f360c80"]])

export default __exports__